'use client';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, IconButton, Typography } from '@mui/material';

import { useT } from '@/hooks';

interface MobileLimitPriceInputProps {
  limitPrice: number;
  onDecrease: () => void;
  onIncrease: () => void;
}

export function MobileLimitPriceInput({
  limitPrice,
  onDecrease,
  onIncrease,
}: MobileLimitPriceInputProps) {
  const { t } = useT();
  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 1.5,
        }}
      >
        <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary' }}>
          {t('trade.limitPrice')}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton
            size="small"
            onClick={onDecrease}
            sx={{
              bgcolor: 'action.hover',
              width: 32,
              height: 32,
              '&:hover': {
                bgcolor: 'action.selected',
              },
            }}
          >
            <RemoveIcon sx={{ fontSize: '1rem' }} />
          </IconButton>
          <Typography
            sx={{
              fontSize: '1.125rem',
              fontWeight: 700,
              color: 'text.primary',
              minWidth: 50,
              textAlign: 'center',
            }}
          >
            {limitPrice}¢
          </Typography>
          <IconButton
            size="small"
            onClick={onIncrease}
            sx={{
              bgcolor: 'action.hover',
              width: 32,
              height: 32,
              '&:hover': {
                bgcolor: 'action.selected',
              },
            }}
          >
            <AddIcon sx={{ fontSize: '1rem' }} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
}
